<script>
  /* global Global */
  import Header from '../../common/Header.svelte';
  import Footer from '../../common/Footer.svelte';
  import Title from '../../common/Title.svelte';
  import AdminPage from '../../ui-components/AdminPage.svelte';
  import ALL_LINKS_EXT_FIELDS from '../../js/extFields/allLinksExtFields.js';

  let lang;
  let user;

  const i18n = {
    pageTitle: {
      cs: `Admin | ${Global.project.name.cs}`,
      en: `Admin | ${Global.project.name.en}`,
    },
  };
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='admin/links' bind:lang bind:user/>

<Title/>

<AdminPage page='links' fields={ALL_LINKS_EXT_FIELDS} bind:lang bind:user/>

<Footer bind:lang/>
